<template>
    <div v-if="config.display" v-show="!config.hideControl" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <logic-editor
            :cId="'logicEditor__' + config.id"
            :ref="config.ref || config.id"
            :prop-component-id="componentId"
            :prop-logic="value"
            @update:prop-logic="value = $event"
            :disabled="config.disabled"
            :prop-setting="config"
            :prop-logic-loaded="logicLoaded"
            @update:prop-logic-loaded="logicLoaded = $event"
            :prop-other-props="config.otherProps"
            @update:prop-other-props="config.otherProps = $event"
            :prop-validation-errors="config.validationErrors"
            @update:prop-validation-errors="setValidationErrors($event)"></logic-editor>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

export const logicControl = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    data() {
        return {
            logicLoaded: false
        };
    },
    watch: {
        value: {
            handler(value) {
                if (this.$parent && this.$parent.$attrs) {
                    this.$parent.$emit('update:value', value);
                }
            },
            deep: true
        },
        items: {
            handler(value) {
                if (this.$parent && this.$parent.$attrs) {
                    this.$parent.$emit('update:items', value);
                }
            },
            deep: true
        }
    },
    methods: {
        clearValue() {
            if (this.config.disabled) return;
            this.value = '';
        },
        setValidationErrors(value) {
            this.config.validationErrors = value;
        }
    },
    computed: {
        componentId() {
            return this.config.componentId || this.component.componentId;
        }
    }
};

export default logicControl;
</script>
